/**
 * @generated SignedSource<<cec9d6bf228902cf556f738cdfea5739>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BylineClassification_content$data = {
  readonly id: string | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly space: {
    readonly alias: string | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
  } | null;
  readonly status: string | null;
  readonly title: string | null;
  readonly type: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"useContentClassification_content">;
  readonly " $fragmentType": "BylineClassification_content";
};
export type BylineClassification_content$key = {
  readonly " $data"?: BylineClassification_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"BylineClassification_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "useClassificationLevelV2"
    }
  ],
  "kind": "Fragment",
  "name": "BylineClassification_content",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "alias"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "useClassificationLevelV2",
          "variableName": "useClassificationLevelV2"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useContentClassification_content"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "4d2a0647887ac7997f379b0d32c129ab";

export default node;
